export { SearchBox, SearchBoxWithLiveResults, SearchResultLiveRegion, getSearchResultLiveRegionText } from './src/index';
